import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { Text } from "@redotech/arbiter/text";

export function MinimumPurchaseAmountField({
  value,
  setValue,
}: {
  value: number | undefined;
  setValue: (value: number | undefined) => void;
}) {
  return (
    <RedoTextInput
      fullWidth
      htmlPattern="^[0-9.]*$"
      inputTypeHint="number"
      label="Minimum purchase amount"
      placeholder="0.00"
      setValue={(value) => {
        setValue(value ? Number(value) : undefined);
      }}
      trailingActions={
        <Text fontSize="sm" textColor="secondary">
          $
        </Text>
      }
      value={value?.toString() ?? ""}
    />
  );
}
